/* eslint-disable */
import * as Types from '../../../models/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type DeleteDomainVariablesDTO = Types.Exact<{
  id: Types.Scalars['String'];
}>;


export type DeleteDomainDTO = (
  { __typename?: 'Mutation' }
  & { updateOneDomain: (
    { __typename?: 'Domain' }
    & Pick<Types.DomainDTO, 'id'>
  ) }
);


export const DeleteDomainDocumentDTO = gql`
    mutation deleteDomain($id: String!) {
  updateOneDomain(id: $id, data: {archived: true}) {
    id
  }
}
    `;
export type DeleteDomainMutationFnDTO = Apollo.MutationFunction<DeleteDomainDTO, DeleteDomainVariablesDTO>;

/**
 * __useDeleteDomain__
 *
 * To run a mutation, you first call `useDeleteDomain` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDomain` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDomain, { data, loading, error }] = useDeleteDomain({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDomain(baseOptions?: Apollo.MutationHookOptions<DeleteDomainDTO, DeleteDomainVariablesDTO>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDomainDTO, DeleteDomainVariablesDTO>(DeleteDomainDocumentDTO, options);
      }
export type DeleteDomainHookResult = ReturnType<typeof useDeleteDomain>;
export type DeleteDomainMutationResultDTO = Apollo.MutationResult<DeleteDomainDTO>;
export type DeleteDomainMutationOptionsDTO = Apollo.BaseMutationOptions<DeleteDomainDTO, DeleteDomainVariablesDTO>;